import type { EventFilter, TelemetryEvent } from './types';

/**
 * Truncates `error.message` to `maxChars` in place on events with `error.source === 'console'`.
 * Never drops an event.
 */
export function capConsoleErrorMessage<T extends TelemetryEvent>(maxChars: number): EventFilter<T> {
  return (event) => {
    const message = event.error?.message;
    if (event.type === 'error' && event.error?.source === 'console' && message && message.length > maxChars) {
      event.error.message = message.slice(0, maxChars);
    }
    return true;
  };
}
